enum ContractStatusEnum {
  PENDING_APPROVAL = "PENDING_APPROVAL",
  PENDING_FINAL_WEIGHT = "PENDING_FINAL_WEIGHT",
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  DELETED = "DELETED",
  ARCHIVED = "ARCHIVED",
}

export default ContractStatusEnum;
